import Swiper from 'swiper/bundle'
import imagesLoaded from 'imagesloaded'
import enterView from 'enter-view'
import GLightbox from 'glightbox'
import MoveTo from 'moveTo'

export default {
  init() {
    const productWrap = document.querySelector('.home-product')
    const productItems = document.querySelectorAll('.product-item')
    const scrollicon = document.querySelector('.slideshow-scrollicon')
    const slideshow = document.querySelector('.slideshow')
    const slideshowContainer = document.querySelector(
      '.slideshow-swiper-container'
    )
    const loader = document.querySelector('.loader')

    const slideshowSwiper = new Swiper(slideshowContainer, {
      lazy: {
        loadPrevNext: true,
      },
      autoplay: {
        delay: 4000,
      },
      effect: 'fade',
      init: false,
      loop: false,
      speed: 800,
      autoHeight: true,
      grabCursor: true,
      spaceBetween: 0,
      preventClicksPropagation: false,
      pagination: {
        el: slideshowContainer.querySelector('.pagination'),
        clickable: true,
        renderBullet(index, className) {
          return `<span class="${className}">${
            index + 1
          }<div class="rippleJS"></div></span>`
        },
      },
      navigation: {
        nextEl: slideshowContainer.querySelector('.next'),
        prevEl: slideshowContainer.querySelector('.prev'),
      },
    })

    imagesLoaded(slideshow, () => {
      slideshow.classList.remove('is-loading')
      document.body.classList.remove('is-loading')
      setTimeout(() => {
        slideshowSwiper.init()
        loader.remove()
      }, 1200)
    })

    slideshowSwiper.on('slideChangeTransitionEnd init', (swiper) => {
      swiper.slides.forEach((element) => {
        element.classList.remove('is-active')
      })

      swiper.slides[swiper.realIndex].classList.add('is-active')
      // swiper.addClass('asdasdas')
    })

    scrollicon.addEventListener('click', (event) => {
      event.preventDefault()
      const moveTo = new MoveTo({ tolerance: -1 })
      moveTo.move(document.querySelector('.main-content'))
    })

    const aboutWrapper = document.querySelector('.home-about-wrapper')
    const fakeHieght = document.querySelector('.home-about-fakehieght')
    const intro = document.querySelector('.home-about-intro')
    const content = document.querySelector('.home-about-content')

    imagesLoaded(aboutWrapper, (instance) => {
      const width = intro.offsetWidth + content.offsetWidth
      fakeHieght.style.height = `${width}px`
      aboutWrapper.style.width = `${width}px`

      enterView({
        selector: '.home-about',
        enter: (el) => {
          el.classList.add('entered')
        },
        offset: 1,
        progress: (el, progress) => {
          const width = window.innerWidth
          let percent = 0

          switch (true) {
            case width >= 1700:
              percent = 70
              break

            case width >= 1600:
              percent = 72
              break

            case width >= 1500:
              percent = 73
              break

            case width >= 1400:
              percent = 74
              break

            case width >= 1300:
              percent = 75
              break

            case width >= 1200:
              percent = 78
              break

            default:
              percent = 87
              break
          }

          if (progress < 0.72 && width > 1199) {
            console.log(percent)
            aboutWrapper.style.transform = `translateX(-${progress * percent}%)`
          }
        },
        exit: (el) => {
          el.classList.remove('entered')
        },
      })
    })

    productItems.forEach((element) => {
      element.addEventListener('mouseover', (event) => {
        for (let index = 0; index < productItems.length; index++) {
          productItems[index].classList.remove('is-hover')
        }
        productWrap.dataset.hover = element.dataset.item
        element.classList.add('is-hover')
      })
    })

    const lightbox = GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
    })
    // window.addEventListener('scroll', () => {
    //   const viewportHeight = window.innerHeight
    //   const pixelScrolled = window.scrollY - viewportHeight
    //   const totalHeightScrollable =
    //     document.body.scrollHeight - about.offsetWidth

    //   if (pixelScrolled > 0) {
    //     const pixelsToPercentage =
    //       (pixelScrolled / (totalHeightScrollable - viewportHeight)) * 100

    //     if (pixelsToPercentage < 75) {
    //       about.style.transform = `translateX(-${pixelsToPercentage}%)`
    //     }
    //     console.log(pixelsToPercentage)
    //   }
    // })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
}
